import React from "react";
import { Scissors, Sprout, TreeDeciduous, Axe, Shovel, ClipboardCheck, Leaf } from "lucide-react";

const MAP = { Scissors, Sprout, TreeDeciduous, Axe, Shovel, ClipboardCheck, Leaf };

export default function ServiceIcon({ name, ...props }) {
  const Icon = MAP[name] || Leaf;
  return <Icon {...props} />;
}
